import App from "../index";
import {debounce, elementHeight, elementY} from "../helpers";
import {ResponsiveSize} from "./responsive-watcher";

export default class ParallaxManager
{

	app: App;
	protected parallaxElements: {
		el: Element,
		offset: number,
		y: number,
		height: number,
	}[] = [];

	public prevScroll: number = 0;
	public scroll: number = 0;
	public pageHeight: number = 0;
	public windowHeight: number = 0;
	public enabled: boolean = false;


	constructor(app: App) {
		
		this.onResize = debounce(this.onResize.bind(this), 250);

		this.onScroll = this.onScroll.bind(this);
		
		this.app = app;
		this.scroll = window.scrollY;
		this.prevScroll = window.scrollY;
		this.setupParallax();
		
		document.addEventListener('responsivechange', this.onResponsiveChange.bind(this));
		
		this.onResponsiveChange(null);
		
	}

	toggleParallax(enable: boolean)
	{
		if (enable) {
			window.addEventListener("scroll", this.onScroll);
			window.addEventListener("resize", this.onResize);
			this.enabled = true;
			this.onResize();
		}
		else {
			window.removeEventListener("scroll", this.onScroll);
			window.removeEventListener("resize", this.onResize);
			this.enabled = false;
			for (let i: number = 0; i < this.parallaxElements.length; i++)
			{
				(this.parallaxElements[i].el as HTMLElement).style.removeProperty('transform');
			}
		}
		
	}
	

	recalculate() {
		if (!this.enabled) return;
		this.pageHeight = elementHeight(document.documentElement);
		this.scroll = window.scrollY;
		this.prevScroll = window.scrollY;
		this.windowHeight = window.innerHeight;

		for (let i = 0; i < this.parallaxElements.length; i++)
		{
			this.parallaxElements[i].height = elementHeight(this.parallaxElements[i].el);
			this.parallaxElements[i].y = elementY(this.parallaxElements[i].el);
		}
	}

	public setupParallax()
	{
		this.parallaxElements = [];
		const els:NodeListOf<Element> = document.querySelectorAll('[data-parallax]');
		for (let i= 0; i < els.length; i++)
		{
			// @ts-ignore
			let offset = parseFloat(els[i].dataset?.parallax ?? 0);
			if (offset <= 0.0001 && offset >= -0.0001) continue;

			this.parallaxElements.push({
				el: els[i],
				offset: offset,
				y: 0,
				height: 0,
			});
		}
	}

	onScroll() {
		this.prevScroll = this.scroll;
		this.scroll = window.scrollY;
		this.processParallax();
	}

	processParallax()
	{
		if (!this.enabled) {
			for (let i: number = 0; i < this.parallaxElements.length; i++)
			{
				(this.parallaxElements[i].el as HTMLElement).style.removeProperty('transform');
			}
			return;
		}
		
		const halfWindow: number = (this.scroll+this.windowHeight*0.5);
		for (let i: number = 0; i < this.parallaxElements.length; i++)
		{
			const e = this.parallaxElements[i];
			if (this.scroll >= e.y-this.windowHeight*2 && this.scroll <= e.y+e.height+this.windowHeight*2)
			{
				let progress: number = (halfWindow - (e.y+e.height*0.5)) / this.windowHeight;

				// @ts-ignore
				e.el.style.transform = "translateY(" + ((progress-0.5) * -100 * this.parallaxElements[i].offset) + "%)";
			}
		}
	}

	onResize()
	{
		this.recalculate();
		this.onScroll();
	}
	
	onResponsiveChange(e:CustomEvent)
	{
		this.toggleParallax(this.app.responser.isGreaterThanOrEqualTo(ResponsiveSize.lg));
	}

}
